var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"primary--text",class:_vm.$vuetify.breakpoint.lgAndUp ? 'display-1' : 'headline',attrs:{"data-cy":"titulo_pagina"}},[_vm._v("\n  "+_vm._s(_vm.titulo)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }